<template>
  <div class="CatWebPcIndex">
    <!-- 详情信息 -->
    <div class="info-card">
      <!-- 作业名称 -->
    
        <div class="job-box">

          <el-breadcrumb v-if="testWork !== 2" separator="/">
            <el-breadcrumb-item :to="{ name: 'myTest' }">{{$t('jobManagementV2.myTest')}}
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{$t('jobManagementV2.testDetails')}}</el-breadcrumb-item>
          </el-breadcrumb>

          <el-breadcrumb v-if="testWork == 2" separator="/">
            <el-breadcrumb-item :to="{ name: 'studentTest' }">{{$t('jobManagementV2.studentTest')}}
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{$t('jobManagementV2.testDetails')}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="back-btn" @click="goback()">
          <span class="back-text">{{$t('jobManagementV2.goBack')}}</span>
        </div>
      
      <div class="teacher-side" v-if="testWork==2">
        <p class="name">{{jobInfo.name}}</p>
        <p :class="[jobInfo.finish==1?'state':'state1']">
          <i v-if="jobInfo.finish==1">{{$t('projectDetailsV2.completed')}}</i>
          <i v-else>{{$t('jobManagementV2.incomplete')}}</i>
        </p>
        <p class="schedule">
          <el-progress :percentage="jobInfo.progress||0"></el-progress>
        </p>
        <p>
        </p>
      </div>
      <div class="job-schedule" v-else>
        <p>{{jobInfo.name}}</p>
        <p>
          <el-progress :percentage="progress||0"></el-progress>
        </p>
      </div>
      <ul :class="[$i18n.locale === 'zh'? 'information' : 'enformation']">
        <li>
          <span class="information-title">{{ $t("projectV2.langDesc") }}：</span>
          <!-- <el-tooltip class="item"
            effect="dark"
            :content="jobInfo.creator"
            placement="bottom"> -->
          <span class="information-text directions">{{ $i18n.locale === "zh"
              ? jobInfo.sourceLangName + ' — ' + jobInfo.targetLangName
              : $langCase[jobInfo.sourceLang] + ' — ' + $langCase[jobInfo.targetLang]}}</span>

          <!-- </el-tooltip> -->
        </li>
        <li>
          <span class="information-title">{{ $t("projectV2.domain") }}：</span><span
                class="information-text">{{ $i18n.locale === 'zh' ? jobInfo.domain : $domainCase[jobInfo.domainCode] }}</span>
        </li>
        <li>
          <span class="information-title">{{ $t("jobManagementV2.wordNumber") }}：</span>
          <span v-if="jobInfo.sourceWordNum === 0" class="information-text">{{
            $t("jobManagementV2.fileParsing")
          }}</span>
          <span v-else class="information-text">{{
            jobInfo.sourceWordNum
          }}</span>
        </li>
        <li>
          <span class="information-title">{{ $t("jobManagementV2.sentenceNumber") }}：</span>
          <span class="information-text" v-if="jobInfo.sentCount === 0">{{
            $t("jobManagementV2.fileParsing")
          }}</span>
          <span class="information-text" v-else>{{ jobInfo.sentCount }}</span>
        </li>
        <li>
          <span class="information-title">{{ $t("projectV2.creator") }}：</span>
          <el-tooltip class="item" effect="dark" :content="jobInfo.creator" placement="bottom">
            <span class="information-text creator">{{ jobInfo.creator }}</span>
          </el-tooltip>
        </li>
        <li>
          <span class="information-title">{{ $t("projectV2.createTime") }}：</span><span
                class="information-text">{{ jobInfo.createTime }}</span>
        </li>
        <li>
          <span class="information-title">{{ $t("jobManagementV2.startTime") }}：</span><span
                class="information-text">{{ jobInfo.startTime}}</span>
        </li>
        <li>
          <span class="information-title">{{ $t("projectV2.limitTime") }}：</span><span
                class="information-text">{{ jobInfo.deliveryTime }}</span>
        </li>
      </ul>
      <!-- <ul class="information">
        
      </ul>
      <ul></ul> -->
    </div>
    <!-- 表格数据 -->
    <div class="table-card">
      <div class="btn-box">
        <div class="btn-box-left">

          <button class="download-report" v-if="userLevel === 1&&(!downloadDisplay)"
                  @click="getFileDownloadUrl()">
          <span>{{
              $t("jobManagementV2.downloadReport")
            }}</span>
              <img src="./assets/images/download.png" />
          </button>

          <button class="download-reportForbidden" disabled="disabled"
                  v-if="userLevel === 1&&downloadDisplay" @click="getFileDownloadUrl()">
           <span>{{
              $t("jobManagementV2.downloadReport")
            }}</span>
             <img src="./assets/images/download.png" />
          </button>

          <button class="distribution" v-if="userLevel === 1" @click="distribution()">
           <span>{{
              $t("jobManagementV2.distribution")
            }}</span>
             <!-- <img src="./assets/images/distribution.png" /> -->
          </button>
          <button class="edit" v-if="userLevel === 1" @click="edit()">
           <span>{{
              $t("jobManagementV2.editor")
            }}</span>
             <!-- <img src="./assets/images/edit.png" /> -->
          </button>
        </div>
        <div class="btn-box-right">
          <button class="delete" v-if="userLevel === 1" @click="deleteTest()">
            {{ $t("projectV2.delete") }}
          </button>
        </div>
      </div>
      <el-table height="calc(100% - 60px)" :data="tableData" border :header-cell-style="{
         'font-weight':'bold',
          background: '#F3F7FE',
          height:'50px',
         padding:0,
          color: '#566087',
        }" style="width: 100%" :default-sort="{ prop: 'date', order: 'descending' }"
                @sort-change="sortChange">
        <el-table-column  :resizable='false' :label="$t('projectV2.index')" width="69" align="center">
          <template slot-scope="scope">
            <span v-text="getIndex(scope.$index)"> </span>
          </template>
        </el-table-column>
        <el-table-column :resizable='false' :label="$t('jobManagementV2.userName')" align="center" prop="userName">
        </el-table-column>
        <el-table-column :resizable='false' :label="$t('jobManagementV2.finishTime')" align="center" prop="finishTime"
                         sortable>
          <template slot-scope="scoped">
            <span v-if="!scoped.row.finishTime">-</span>
            <span v-else>{{ scoped.row.finishTime }}</span>
          </template>
        </el-table-column>
        <el-table-column :resizable='false' :label="$t('jobManagementV2.testProgress')" align="center" width="300"
                         prop="progress">
          <template slot-scope="scoped">
            <el-progress :percentage="scoped.row.progress"></el-progress>
          </template>
        </el-table-column>
        <el-table-column :resizable='false' :label="$t('projectV2.state')" width="190" align="center" prop="finish">
          <template slot-scope="scoped">
            <div v-if="scoped.row.finish === 1" class="completed">
              
              <span>{{$t("jobManagementV2.completed")}}</span>
            </div>
            <div v-if="scoped.row.finish === 0" class="incomplete">
             
              <span>{{$t("jobManagementV2.notStarted")}}</span>
            </div>
            <div v-if="scoped.row.finish === 2" class="underway">
           
              <span>{{$t("jobManagementV2.ongoing")}}</span>
            </div>
            <div v-if="scoped.row.finish === 3" class="overdue">
         
              <span>{{$t("jobManagementV2.overdue")}}</span>
            </div>
            <div v-if="scoped.row.finish === 4" class="overdueComplete">
             
              <span>{{$t("jobManagementV2.overdueComplete")}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('projectV2.operation')" width="227" align="center">
          <template slot-scope="scoped">
            <el-tooltip class="item" effect="dark" :content="$t('projectV2.check')" placement="top">
              <div class="check"><span @click="toEdit(scoped.row)"></span></div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 编辑弹窗 -->
    <edit-test :listLength="listLength" @getjobInfo="getjobInfo"></edit-test>
    <!-- 分配弹窗 -->
    <distribution-dialog></distribution-dialog>
    <!-- 删除弹窗 -->
    <deleteFile :deleteVisible="isShow" @deleteCancel="isShow = false" @handleOk="confirmdDeletion"
                :content="$t('projectV2.deleteTest')"></deleteFile>

  </div>
</template>

<script>
import EditTest from "../../components/layer/studentJob/editTest";
import deleteFile from '../../components/layer/fileDialog/deleteFile';
import DistributionDialog from "../../components/layer/studentJob/distributionDialog";
import { deleteProject } from "../../services/myProjectApi";
import {
  queryProjectTermMemoryList,
  queryMyTaskPage,
  queryTaskPage,
  queryFile,
  getWorkReport,
} from "../../services/jobManagement";
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.path = from.path;
    });
  },
  name: "CatWebPcIndex",
  components: {
    EditTest,
    deleteFile,
    DistributionDialog,
  },
  data() {
    return {
      isShow: false,
      tableData: [],
      pattern: null,
      jobInfo: {
        domain: "",
        domainCode: "",
        name: "",
        startTime: "",
        deliveryTime: "",
        createTime: "",
        startTime: "",
        sourceLang: "",
        sourceLangName: "",
        targetLang: "",
        targetLangName: "",
        creator: "",
        sourceWordNum: "",
        finish: "",
        progress: "",
      },
      path: null,
      sourceWordNum: null,
      pageReqDto: {},
      fileId: null,
      dialogVisible: true,
      userLevel: 1, //默认教师端
      listLength: null,
      downloadDisplay: true,
      testWork: null,
      progress: 0,
      queryData: {},
    };
  },

  created() {
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
    if (this.queryData.test == 2) {
      this.testWork = 2
    }
    if (this.queryData.userLevel) {
      this.userLevel = this.queryData.userLevel;
    }
    this.queryProjectInfo();
    this.queryFileInfo();
  },
  mounted() { },

  methods: {
    getjobInfo() {
      this.queryProjectInfo()
    },
    //排序
    sortChange({ prop, order }) {
      if (order == "descending") {
        order = "desc";
      } else if (order == "ascending") {
        order = "asc";
      } else if (order === null) {
        order = "asc";
      }
      if (prop === 'finishTime') {
        this.sort = { finishTime: order }
        this.queryStudentPro()
      }
    },
    // 查询项目详情---名称,领域,截止时间
    queryProjectInfo() {
      let params = {
        id: this.queryData.id,
      };
      queryProjectTermMemoryList(params).then(({ result }) => {
        this.jobInfo.domain = result.domain;
        this.jobInfo.domainCode = result.domainCode
        this.jobInfo.name = result.name;
        this.jobInfo.deliveryTime = result.deliveryTime;
        this.jobInfo.sourceLang = result.sourceLang
        this.jobInfo.sourceLangName = result.sourceLangName;
        this.jobInfo.targetLang = result.targetLang
        this.jobInfo.targetLangName = result.targetLangName;
        this.jobInfo.creator = result.creator;
        this.jobInfo.createTime = result.createTime;
        this.jobInfo.startTime = result.startTime;
        this.jobInfo.finish = result.finish;
        this.jobInfo.progress = result.progress;
      });
    },
    // 获取字数
    queryFileInfo() {
      let params = { id: this.queryData.id };
      queryFile(params).then(({ result }) => {
        this.jobInfo.sourceWordNum = result[0].sourceWordNum;
        this.jobInfo.sentCount = result[0].sentCount;
        this.fileId = result[0].id;
      });
    },
    // 分配
    distribution() {
      if (new Date() > new Date(this.jobInfo.deliveryTime)) {
        this.$message.closeAll()
        this.$message.warning(this.$t("jobManagementV2.distributionWarning"));
        return false;
      }
      let busParams = {
        dialogVisible: this.dialogVisible,
        limitTime: this.jobInfo.deliveryTime,
        id: this.fileId,
      };
      this.bus.$emit("busParams", busParams);
    },
    // 编辑
    edit() {
      let params = {
        dialogVisible: this.dialogVisible,
        id: this.queryData.id,
        fileId: this.fileId,
        tableDataLength: this.tableData.length,
      };
      this.bus.$emit("params", params);
    },
    // 序号格式化
    getIndex($index) {
      (this.pageReqDto.page - 1) * this.pageReqDto.rows + $index + 1;
      if ($index < 9) {
        return "0" + ($index + 1);
      } else {
        return $index + 1;
      }
    },
    // 返回
    goback() {
      if (this.queryData.userLevel == 2) {
        this.$router.push({ name: 'myTest' });
      } else {
        this.$router.push({ name: 'studentTest' });
      }
    },
    // 根据文件id查询学生进度
    queryStudentPro() {
      let params = {
        rows: 1000,
        filter: {
          sourceType: 2,
          fileId: this.fileId,
          companyCode: this.queryData.companyCode,
          projectId: String(this.queryData.id),
        },
      };
      if (this.userLevel === 1) {
        queryTaskPage(params).then(({ list }) => {
          if (list.length > 0) {
            this.downloadDisplay = false;
          }
          this.tableData = list;
          this.listLength = list.length
          if (this.tableData.length > 0) {
            this.progress = this.tableData[0].progress || 0
          }
        });
      } else {
        queryMyTaskPage(params).then(({ list }) => {
          this.tableData = list;
          if (this.tableData.length > 0) {
            this.progress = this.tableData[0].progress || 0
          }
        });
      }
    },

    deleteTest() {
      this.isShow = true;
    },
    confirmdDeletion() {
      deleteProject({ id: this.queryData.id }).then(({ success }) => {
        if (success) {
          this.$message.success(this.$t("projectV2.success"));
          this.isShow = false;
          this.$router.push({ name: "studentTest" });
        } else {
          this.$message.warning(this.$t("projectV2.error"));
        }
      });
    },
    toEdit(row) {
      if (new Date(row.startTime) > new Date()) {
        this.$message.closeAll()
        this.$message.warning(this.$t('jobManagementV2.testNotStarted'))
        return
      }

      let path = "/neweditor";
      let userRole = "";
      if (this.userLevel === 1) {
        userRole = "teacher-test";
      } else {
        userRole = "student-test";
      }
      let obj = Object();
      let userId = JSON.parse(localStorage.getItem("userInfo")).id;
      Reflect.set(obj, 'sourceLang', (row.sourceLang));
      Reflect.set(obj, 'targetLang', (row.targetLang));
      Reflect.set(obj, 'taskName', (row.taskName));
      sessionStorage.setItem("fileName", row.taskName)
      Reflect.set(obj, 'wordNum', (row.sourceWordNum));
      Reflect.set(obj, 'project', 3);
      Reflect.set(obj, 'userId', (userId || ''));
      Reflect.set(obj, 'transStatus', 1);
      Reflect.set(obj, 'fileSuffix', row.fileUsableSuffix);
      Reflect.set(obj, 'transModel', row.transModel);
      //老版参数
      Reflect.set(obj, "fileId", row.fileId);
      Reflect.set(obj, "projectId", row.projectId);
      Reflect.set(obj, "isSplit", true);
      Reflect.set(obj, "type", "school");
      Reflect.set(obj, "taskType", row.taskType);
      Reflect.set(obj, "taskId", row.id);
      Reflect.set(obj, "type-school", userRole);
      Reflect.set(obj, "companyCode", this.queryData.companyCode);
      let routeData1 = this.$router.resolve({
        path,
        query: {
          key: this.$Base64.encode(JSON.stringify(obj)),
        },
      });
      window.open(routeData1.href, "_self");
    },
    getFileDownloadUrl() {
      getWorkReport({ id: this.fileId }).then(({ result, status, success, errorDesc }) => {
        if (success && status == 200) {
          window.location.href = (result);
        } else {
          this.$message.closeAll()
          this.$message.error(errorDesc)
          return
        }
      });
    },
  },
  watch: {
    fileId: {
      handler() {
        this.queryStudentPro();
      },
    },
  },
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
